import React from 'react';
import styles from './Key.css';
export const Key = () => (React.createElement("span", { className: styles.key },
    React.createElement("span", { className: styles.keyCap }, "Enter")));
